// The view controls the task list pages share. One switch today.
//
// Its own component rather than a branch inside LogbookViewControls: that one
// owns the Entries/Trips toggle and Show notes, neither of which means anything
// here, and merging them would put two pages' controls behind one set of props.
//
// Mounted only by a host that actually loads photos (Tasks.jsx,
// AssignedTasks.jsx, and the shared list), so the switch can never be a control
// with no read behind it -- the `showPhotosToggle` idiom, applied by
// co-location instead of a prop because there is only ever one switch to gate.

import Form from 'react-bootstrap/Form';

export function TaskViewControls({ showPhotos, onShowPhotosChange }) {
  return (
    <div className="d-flex align-items-center flex-wrap gap-3">
      {/* `label` is what gives the switch its accessible name -- nothing else
          may go inside that prop or getByLabelText stops finding it. */}
      <Form.Check
        type="switch"
        id="tasks-show-photos"
        label="Show photos"
        checked={showPhotos}
        onChange={(e) => onShowPhotosChange(e.target.checked)}
      />
    </div>
  );
}

export default TaskViewControls;
